var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22691 4.46974C1.36756 4.32914 1.55829 4.25015 1.75716 4.25015C1.95604 4.25015 2.14677 4.32914 2.28741 4.46974L5.99991 8.18224L9.71241 4.46974C9.85387 4.33313 10.0433 4.25753 10.24 4.25924C10.4366 4.26095 10.6247 4.33982 10.7638 4.47888C10.9028 4.61794 10.9817 4.80605 10.9834 5.00269C10.9851 5.19934 10.9095 5.38879 10.7729 5.53024L6.53016 9.77299C6.38952 9.9136 6.19879 9.99258 5.99991 9.99258C5.80104 9.99258 5.61031 9.9136 5.46966 9.77299L1.22691 5.53024C1.08631 5.3896 1.00732 5.19887 1.00732 4.99999C1.00732 4.80112 1.08631 4.61039 1.22691 4.46974Z",
    fill: "#66666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/linkArrow.62a2a152918b2b73f07b38c866603637.svg";
export { ForwardRef as ReactComponent };